import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, TrendingUp } from 'lucide-react';
export function UrgencySection() {
  return <section className="w-full bg-[#0a0f1a] py-12 md:py-20 px-4 relative border-t border-[#c9a84c]/10" data-id="element-204">
      <div className="max-w-4xl mx-auto" data-id="element-205">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-206">
          {/* Left: Price Anchor */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-207">
            <h3 className="font-serif text-xl md:text-3xl text-white" data-id="element-208">
              Why $6.36?
            </h3>
            <p className="text-[#f5f0e8]/80 text-base md:text-lg leading-relaxed" data-id="element-209">
              Real estate mentorships cost{' '}
              <span className="text-[#ef4444] line-through" data-id="element-210">$5,000</span>.
              Weekend seminars cost{' '}
              <span className="text-[#ef4444] line-through" data-id="element-211">$2,000</span>. The
              regular price of this blueprint is{' '}
              <span className="text-[#ef4444] line-through" data-id="element-212">$47</span>.
            </p>
            <p className="text-[#f5f0e8]/80 text-base md:text-lg leading-relaxed" data-id="element-213">
              Right now, you're getting it for{' '}
              <span className="text-[#c9a84c] font-bold text-xl" data-id="element-214">$6.36</span> —
              that's <span className="text-[#10b981] font-bold" data-id="element-215">86% off</span>.
              I want to build a network of 10,000 Shadow Providers by 2026 to
              launch a national brand. I need your success story more than I
              need your money.
            </p>
            <div className="bg-[#c9a84c]/10 p-4 rounded-lg border border-[#c9a84c]/20" data-id="element-216">
              <p className="text-[#c9a84c] font-bold" data-id="element-217">
                Fair Warning: Price returns to $47 when this promotion ends.
                Future price: $197.
              </p>
            </div>
            <div className="bg-[#10b981]/5 p-4 rounded-lg border border-[#10b981]/20" data-id="element-218">
              <p className="text-[#10b981] font-bold text-center text-lg" data-id="element-219">
                You're saving $40.64 today
              </p>
            </div>
          </motion.div>

          {/* Right: Market Urgency */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-[#1a2332] p-5 md:p-8 rounded-xl border border-[#c9a84c]/10 relative overflow-hidden" data-id="element-220">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-221">
              <TrendingUp className="w-24 h-24 text-[#c9a84c]" data-id="element-222" />
            </div>

            <div className="flex items-start gap-4 mb-6" data-id="element-223">
              <AlertTriangle className="w-6 h-6 md:w-8 md:h-8 text-[#c9a84c] flex-shrink-0" data-id="element-224" />
              <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-225">
                The 2025 Window Is Closing
              </h3>
            </div>

            <p className="text-[#f5f0e8]/80 mb-3 md:mb-4 text-sm md:text-base" data-id="element-226">
              The Sun-Belt market is shifting. Corporate housing demand is
              peaking <span className="font-bold text-white" data-id="element-227">RIGHT NOW</span> in
              Austin and Tampa.
            </p>
            <p className="text-[#f5f0e8]/80 text-sm md:text-base" data-id="element-228">
              Every month you wait is another $1,100 in profit you're leaving on
              the table. Inflation isn't waiting for you to be ready.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}